/* eslint-disable react/no-array-index-key */
// react
import React from "react";

import { faEnvelope, faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// components
import Button from "../../../../components/Button";
import TextInput from "../../../../components/Inputs/TextInput";

// dependencies
import PropTypes from "../../../../lib/prop-types";

// styles
import css from "../SftpSettings.module.scss";

const AddIntegrationEmails = (props) => {
	const { integrationEmailList, addIntegrationEmail, removeIntegrationEmail, updateIntegartionEmail } = props;

	return (
		<div>
			<div className={css.modalDescription}>Integration Email List (Optional)</div>
			<div className={css.moreDescription}>
				Enter email addresses that should receive updates when syncs are completed.
			</div>
			{integrationEmailList.map((email, ii) => (
				<div key={`${ii}-emailList`}>
					<div className={`${css.modalInput}`} style={{ width: "90%", float: "left" }}>
						<TextInput
							maxLength={50}
							value={email}
							onChange={(val) => {
								updateIntegartionEmail(ii, val);
							}}
						/>
					</div>
					<div key={`${ii}-remove`} style={{ width: "9%", float: "right", top: "12px" }}>
						<span className={css.inputIcon} onClick={() => removeIntegrationEmail(ii)}>
							<FontAwesomeIcon icon={faTimes} data-testid={faTimes.iconName} />
						</span>
					</div>
				</div>
			))}

			<div
				style={{
					display: "flex",
					justifyContent: "space-evenly",
					width: "90%",
				}}
			>
				<Button
					version={2}
					color="grey"
					style={{ width: "100%", marginTop: "10px" }}
					onClick={() => {
						addIntegrationEmail("");
					}}
				>
					{" "}
					<FontAwesomeIcon
						icon={faEnvelope}
						style={{ marginRight: "4px" }}
						data-testid={faEnvelope.iconName}
					/>{" "}
					Add Email{" "}
				</Button>
			</div>
		</div>
	);
};

AddIntegrationEmails.propTypes = {
	integrationEmailList: PropTypes.array.isRequired,
	addIntegrationEmail: PropTypes.func.isRequired,
	removeIntegrationEmail: PropTypes.func.isRequired,
	updateIntegartionEmail: PropTypes.func.isRequired,
};

export default AddIntegrationEmails;
